export const MERCHANT_LEGAL_NAME_EN = 'AETHER VISION TECHNOLOGY LIMITED';
export const MERCHANT_LEGAL_NAME_ZH = '以太視覺人工智能有限公司';
export const MERCHANT_BUSINESS_REGISTRATION_NO = '79987211-000-03-26-3';
export const MERCHANT_ADDRESS = 'RM 102, 1/F, THE CLOUD, 111 TUNG CHAU STREET, TAI KOK TSUI, HONG KONG';
export const SUPPORT_EMAIL = 'ryan@dobidobi.ai';
export const SUPPORT_PHONE_DISPLAY = '+86 188 1906 0130';
export const SUPPORT_PHONE_HREF = '+8618819060130';

export const CONTACT_EMAIL = 'info@dobidobi.ai';
